<mat-card>
  <div class="error">
    <div>Någonting blev fel</div>
    @if (errorMessage) {
      <div>"{{ errorMessage }}"</div>
    }
  </div>
  <spb-try-again buttonText="Försök igen"></spb-try-again>
</mat-card>